import axios from '../../axios-dashboard'

import * as actionTypes from './actionTypes'

export const fetchXogroupsStart = () => {
    return {
        type: actionTypes.XOGROUPS_FETCH_START
    }
};

export const fetchXogroupsSuccess = (groups, index, callBackNeeded) => {
    return {
        type: actionTypes.XOGROUPS_FETCH_SUCCESS,
        xogroups: groups || [],
        selectedId: index,
        callBackNeeded: index !== null && groups.length > 0,
    }
};

export const fetchXogroupsFail = (error) => {
    return {
        type: actionTypes.XOGROUPS_FETCH_FAIL,
        error: error,
    }
};

export const editXogroupsStart = () => {
    return {
        type: actionTypes.EDIT_XOGROUPS_START
    }
};

export const editXogroupsSuccess = (groups, index) => {
    return {
        type: actionTypes.EDIT_XOGROUPS_SUCCESS,
        xogroups: groups,
        selectedId: index,
    }
};

export const editXogroupsFail = (error) => {
    return {
        type: actionTypes.EDIT_XOGROUPS_FAIL,
        error: error
    }
};

export const fetchGroupActivitiesStart = () => {
    return {
        type: actionTypes.FETCH_GROUP_ACTIVITIES_START
    }
};

export const fetchGroupActivitiesSuccess = (activities) => {
    return {
        type: actionTypes.FETCH_GROUP_ACTIVITIES_SUCCESS,
        activities: activities,
        callBackNeeded: false,
    }
};

export const fetchGroupActivitiesFail = (error) => {
    return {
        type: actionTypes.FETCH_GROUP_ACTIVITIES_FAIL,
        error: error,
        callBackNeeded: false,
    }
};

export const fetchGroupInstancesStart = () => {
    return {
        type: actionTypes.FETCH_GROUP_INSTANCES_START
    }
}

export const fetchGroupInstancesSuccess = (instances, groupName) => {
    return {
        type: actionTypes.FETCH_GROUP_INSTANCES_SUCCESS,
        instances: instances,
        groupName: groupName,
    }
}

export const fetchGroupInstancesFail = (error) => {
    return {
        type: actionTypes.FETCH_GROUP_INSTANCES_FAIL,
        error: error,
    }
}

export const editXogroups = (token, xogroups, previousSelectId) => {
    return dispatch => {
        dispatch(editXogroupsStart());

        const url = "/xogroup-config";
        axios.defaults.headers.common["Authorization"] = 'Bearer ' + token;
        axios.post(url, {
            action: "updateConfigs",
            configs: xogroups,
        }).then(
            response => {
                let groups = response.data
                let index = null
                if (groups && previousSelectId !== null) {
                    groups = groups.map((v, i) => {
                        if (v.id === previousSelectId) {
                            v.trSelected = true
                            index = i
                        }
                        return v
                    })
                }
                dispatch(editXogroupsSuccess(response.data, index))
            }
        ).catch(err => {
            dispatch(editXogroupsFail(err.response.data.error))
        })
    }
};

export const fetchXogroups = (token, previousSelectId) => {
    return dispatch => {
        if (!token) {
            return
        }
        dispatch(fetchXogroupsStart());
        let url = "/xogroup-config";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {
            action: 'getConfigs'
        }).then(response => {
            let groups = response.data
            let index = null
            if (groups && previousSelectId !== null) {
                groups = groups.map((v, i) => {
                    if (v.id === previousSelectId) {
                        v.trSelected = true
                        index = i
                    }
                    return v
                })
            }
            dispatch(fetchXogroupsSuccess(groups, index, true))
        }).catch(err => {
            dispatch(fetchXogroupsFail(err.response.data.error))
        })
    }
};

export const fetchGroupActivities = (token, groupName, page) => {
    return dispatch => {
        dispatch(fetchGroupActivitiesStart());
        let url = "/xogroup-config";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {
            action: 'fetchActivities',
            groupName: groupName,
            pagination: {"page": page, "pageSize": 20},
        }).then(response => {
            dispatch(fetchGroupActivitiesSuccess(response.data))
        }).catch(err => {
            dispatch(fetchGroupActivitiesFail(err.response.data.error))
        })
    }
}

export const fetchGroupInstances = (token, groupName) => {
    return dispatch => {
        dispatch(fetchGroupInstancesStart());
        let url = "xogroup-config";
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
        axios.post(url, {
            action: 'fetchInstances',
            groupName: groupName,
        }).then(response => {
            dispatch(fetchGroupInstancesSuccess(response.data, groupName))
        }).catch(err => {
            dispatch(fetchGroupInstancesFail(err.response.data.error))
        })
    }
}